import { BaseCreateComponent } from "../BaseCreateComponent";

import template from "./template.html";

interface ErrorMessageItem {
  id: number;
  isSuccess: boolean;
  isDanger: boolean;
  isWarning: boolean;
  title: string;
  description: string;
}

class ErrorMessageComponent extends BaseCreateComponent<HTMLDivElement> {
  public addError(title: string, message: string) {
    this._addItem(false, true, false, title, message);
  }

  public addSuccess(title: string, message: string) {
    this._addItem(true, false, false, title, message);
  }

  public addWarning(title: string, message: string) {
    this._addItem(false, false, true, title, message);
  }

  //

  protected getTagName(): string {
    return "div";
  }

  protected getElementId(): string {
    return "errorWrapper";
  }

  //

  private _items: ErrorMessageItem[] = [];
  private _nextId = 0;
  private _listenerAttached = false;

  private _addItem(
    isSuccess: boolean,
    isDanger: boolean,
    isWarning: boolean,
    title: string,
    description: string,
  ) {
    this._attachCloseListener();

    const duplicate = this._items.some(
      (i) => i.title === title && i.description === description,
    );
    if (duplicate) return;

    const item: ErrorMessageItem = {
      id: this._nextId++,
      description: description,
      isDanger: isDanger,
      isSuccess: isSuccess,
      isWarning: isWarning,
      title: title,
    };
    this._items.push(item);
    this._render();

    setTimeout(() => this._remove(item.id), 0.5 * 60 * 1000);
  }

  private _remove(id: number) {
    this._items = this._items.filter((r) => r.id !== id);
    this._render();
  }

  private _render() {
    this.getElement().innerHTML = this.createHtmlString(template, {
      items: this._items,
    });
  }

  private _attachCloseListener() {
    if (this._listenerAttached) return;
    this._listenerAttached = true;
    this.getElement().addEventListener("click", (e) => {
      const btn = (e.target as HTMLElement).closest("[data-id]");
      if (!btn) return;
      this._remove(Number(btn.getAttribute("data-id")));
    });
  }
}

export const errorMessageComponent = new ErrorMessageComponent();
